export const IDownloadImageUseCaseType = Symbol('IDownloadImageUseCase');
